<template>
    <div class="bg-white">
        <div
            v-if="paddinghero"
            class="mobile-show"
            style="margin-top: -150px;"
        ></div>
        <v-container
            grid-list-lg
            fluid
            fill-height
            class="home-hero"
            style="max-height: 100vh;"
        >
            <v-layout row wrap pa-5>
                <v-flex xs12 sm12 md6 m-3 class="order-md-1">
                    <v-responsive>
                        <div class="padding-hero"></div>
                        <h1 class="pr-5">{{ headline }}</h1>
                        <p class="mt-3 font-white font-normal">{{ text }}</p>

                        <div v-show="$route.name == 'about'">
                            <ul class="font-white list-about">
                                <li>We are Collaborative</li>
                                <li>We Foster Lateral Leadership</li>
                                <li>We are Focused to Deliver Results</li>
                                <li>More, Faster, Now</li>
                                <li>We Learn, We Move</li>
                                <li>We are Leaders</li>
                                <li>We Keep Promises</li>
                                <li>We Welcome Everybody</li>
                            </ul>
                        </div>
                        <div class="font-white" v-show="$route.name == 'join'">
                            To join Athena, please follow these steps:
                            <br />
                            <br />
                            <ol class="font-white">
                                <li>
                                    Please read through our On-boarding
                                    information
                                </li>
                                <li>Join via the Join Now Link</li>
                                <li>
                                    In the announcements channel, please state
                                    who you are, what skills you bring and if
                                    you would like to lead a particular work
                                    stream or what idea/project you would like
                                    to work on
                                </li>
                            </ol>
                        </div>
                        <div v-if="button">
                            <v-btn
                                color="white "
                                class="mt-3 mb-5 ml-0 font-normal text-none"
                                height="25px"
                                large
                                to="/join"
                                >Join Now</v-btn
                            >
                        </div>
                        <div v-if="buttonSlack">
                            <v-btn
                                color="white "
                                class="mt-3 mb-5 ml-0 font-normal text-none"
                                height="25px"
                                large
                                href="https://projectathenaco.slack.com/join/shared_invite/zt-f3p49y0w-u0im1B3nAdyD8CKOTqtMtA"
                                >Join Us on Slack!</v-btn
                            >
                        </div>
                    </v-responsive>
                </v-flex>
                <v-flex xs12 sm12 md6 class="order-md-2">
                    <div class="doctor">
                        <v-responsive>
                            <v-img height="200px"></v-img>
                        </v-responsive>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'HomeHero',
    props: {
        headline: {
            type: String
        },
        text: {
            type: String
        },
        button: {
            type: Boolean
        },
        buttonSlack: {
            type: Boolean
        },
        paddinghero: {
            type: Boolean
        }
    }
};
</script>

<style scoped>
@media only screen and (min-width: 768px) {
    .home-hero {
        background: url('../assets/img/Pfad 17429.png');
        background-repeat: no-repeat;
        background-size: contain;
        width: 100%;
        position: relative;
        bottom: 0px;
    }
}

@media only screen and (max-width: 768px) {
    .home-hero {
        background: url('../assets/img/mobilePath@2x.png');
        background-repeat: no-repeat;
        background-size: contain;
        width: 100%;
        position: relative;
        bottom: 100px;
    }
}

.test {
    line-height: 10rem;
}

.doctor {
    background: url('../assets/img/Doctor.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 500px;
}

@import '../assets/styles/variables.scss';
@import '../assets/styles/main.css';
@font-face {
    font-family: 'CircularStd-Bold';
    src: url('../assets/fonts/CircularStd-Bold.woff') format('woff');
    font-display: auto;
}
</style>
